module.exports = __webpack_public_path__ + "img/re-open-jd.23a49900.svg";